import React from 'react';
import {
  Drawer,
  InputGroup,
  FormGroup,
  Intent,
  Button,
} from '@blueprintjs/core';
import {
  DrawerHeader,
  PlainButton,
  FlexRow,
  PaddingWrapper,
} from 'components/styled-components';
import { Formik, Form, ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import * as Yup from 'yup';
import { AppToaster } from 'components/AppToaster';
import { createDepartment } from 'api/utils';

const ValidationSchema = Yup.object().shape({
  departmentName: Yup.string()
    .min(1, 'Too Short!')
    .max(200, 'Too Long!')
    .required('Required'),
  description: Yup.string()
    .min(1, 'Too Short!')
    .max(500, 'Too Long!')
    .required('Required'),
});

const AddDepartmentDrawer = ({ toggleOpen, isOpen, fetch }) => {
  const handleClose = reset => {
    reset();
    toggleOpen(false);
  };

  const submit = (values, actions) => {
    actions.setSubmitting(true);
    createDepartment({ ...values })
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        actions.resetForm();
        handleClose(fetch);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        actions.setSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={{
        departmentName: '',
        description: '',
      }}
      onSubmit={submit}
      validationSchema={ValidationSchema}
      validateOnBlur={true}
    >
      {({ handleChange, values, handleReset, isSubmitting }) => (
        <Drawer
          isOpen={isOpen}
          onClose={() => handleClose(handleReset)}
          lazy
          usePortal
        >
          <Form>
            <DrawerHeader>
              <FlexRow>
                <span>Add Department</span>
                <div>
                  <Button
                    text="cancel"
                    minimal
                    onClick={() => {
                      handleClose(handleReset);
                    }}
                  />
                  <PlainButton
                    width="8rem"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    SAVE
                  </PlainButton>
                </div>
              </FlexRow>
            </DrawerHeader>
            <PaddingWrapper>
              <FormGroup label="Department Name" labelFor="name-input">
                <ErrorMessage
                  name="departmentName"
                  render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                />
                <InputGroup
                  large
                  id="name-input"
                  name="departmentName"
                  value={values.departmentName}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup label="Description" labelFor="description-input">
                <ErrorMessage
                  name="description"
                  render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
                />
                <InputGroup
                  large
                  id="description-input"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                />
              </FormGroup>
            </PaddingWrapper>
          </Form>
        </Drawer>
      )}
    </Formik>
  );
};

export default AddDepartmentDrawer;
